var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26316 10.1053C7.26316 8.53561 8.53561 7.26316 10.1053 7.26316H25.8947C27.4644 7.26316 28.7368 8.53561 28.7368 10.1053V25.8947C28.7368 27.4644 27.4644 28.7368 25.8947 28.7368H7.26316V10.1053Z",
    stroke: "#00A68B",
    strokeWidth: 2.52632
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91138 7.24658H26.0886C26.8037 7.24658 27.4895 7.52981 27.9951 8.03397C28.5007 8.53813 28.7848 9.22191 28.7848 9.93489V26.0648C28.7848 26.7778 28.5007 27.4615 27.9951 27.9657C27.4895 28.4698 26.8037 28.7531 26.0886 28.7531H9.91138C9.1963 28.7531 8.51051 28.4698 8.00488 27.9657C7.49924 27.4615 7.21518 26.7778 7.21518 26.0648V9.93489C7.21518 9.22191 7.49924 8.53813 8.00488 8.03397C8.51051 7.52981 9.1963 7.24658 9.91138 7.24658Z",
    stroke: "#00A68B",
    strokeWidth: 2.52632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1519 22.1558C15.4177 23.022 16.6835 23.4545 17.9494 23.4545C19.2152 23.4545 20.481 23.022 21.7468 22.1558",
    stroke: "#00A68B",
    strokeWidth: 2.63158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1519 16.9608V15.6621",
    stroke: "#00A68B",
    strokeWidth: 2.63158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7468 16.9608V15.6621",
    stroke: "#00A68B",
    strokeWidth: 2.63158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/bot_icon.54dd1784.svg";
export { ForwardRef as ReactComponent };